import { DEFAULT_SEGMENT_SETTINGS } from '../constants'

export const initialSegmentSettingsState = {
  segmentSettings: { ...DEFAULT_SEGMENT_SETTINGS },
}
